import { recipients } from './recipients';
import { isID } from '@shared/helpers/uid';
import { debug } from '@shared/helpers/debug';

export const show = {
  namespaced: true,
  state: {
    current_database_id: null
  },
  mutations: {
    database_id(state, id) {
      if (isID(id)) {
        state.current_database_id = id;
      } else {
        debug.warn('Database id is not number');
      }
    }
  },
  modules: {
    recipients
  }
};
